import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import useLocale from '../../lib/hooks/use-locale';

export default function LocaleSelect() {
  const { options, currentLocale, setCurrentLocale, localePrefix } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLocaleChange = (changedLocale) => {
    const selected = changedLocale || options[0];
    setCurrentLocale(selected);
    setIsOpen(false);

    const newPrefix = selected.value === 'ko' ? '' : `/${selected.value}`;
    // 현재 경로에서 기존 locale prefix 제거 후 새 prefix 적용
    const strippedPath = location.pathname.replace(new RegExp(`^${localePrefix}`), '') || '/';
    navigate(newPrefix + strippedPath + location.search + location.hash, { replace: true });
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="component-preview flex items-center">
      <div className="dropdown group relative">
        <button
          className="flex items-center focus:outline-none"
          tabIndex={0}
          onClick={toggleDropdown}
          onBlur={() => setTimeout(() => setIsOpen(false), 150)}
        >
         { currentLocale.value === 'ko' ? "KR" : "JP"}
        </button>
        
        <ul className={`absolute top-full left-0 bg-[#2F2629] rounded-lg border-2 border-gray-900 border-outline-100 p-2 mt-1 flex flex-col gap-2 transition-all duration-300 ease-in-out z-50 
          ${
            isOpen
            ? 'opacity-100 transform pointer-events-auto'
            : 'opacity-0 transform pointer-events-none'
          }
        }`}>
          {options.map(({ value, label, languageIcon }) => (
            <li 
              key={value} 
              className={`
                text-gray-800 hover:text-black 
                hover:bg-[#473a3e] rounded-lg 
                active:text-secondary-600 active:bg-[#overflow-visible] 
                transition-all duration-300 ease-in-out
              `}
              >
              <button onClick={() => handleLocaleChange({ value, label, languageIcon })} className='flex gap-4 py-2 pl-2 pr-8 flex-row items-center w-full text-left'>
                {/* <img className="w-8" alt="" src={value === 'ko' ? "/kr.svg" : "/jp.svg"}/> */}
                <p className='text-14 tabletS:text-base font-medium whitespace-nowrap'>{value === 'ko' ? 'KR' : 'JP'}</p>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
